import React, { useContext, useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Badge from "react-bootstrap/esm/Badge";
import Container from "react-bootstrap/esm/Container";
import Nav from "react-bootstrap/esm/Nav";
import Navbar from "react-bootstrap/esm/Navbar";
import { QrReader } from "react-qr-reader";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { v4 as uuidv4 } from "uuid";
import { Store } from "../Store";
import AskCustomerNameAndApproveOrderModal from "../components/AskNameModal";
import CategoryMenu from "../components/CategoryMenu";
import CustomerCartModal from "../components/CustomerCartModal";
import LoadingBox from "../components/LoadingBox";
import MessageBox from "../components/MessageBox";
import ProductsListForCustomer from "../components/ProductsListForCustomer";
import useAxios from "../hooks/useAxios";
import { getBusinessLabel } from "../utils";
import BusinessBanner from "./BusinessBanner";

export default function QrMenu() {
  const axios = useAxios();
  const { dispatch: ctxDispatch, state } = useContext(Store);
  const { carts, userInfo, table } = state;
  const { search } = useLocation();
  const sp = new URLSearchParams(search);
  const [categories, setCategories] = useState([]);
  const [products, setProducts] = useState([]);
  const [category, setCategory] = useState([]);
  const [firstOrderProducts, setFirstOrderProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [scanBarcode, setScanBarcode] = useState(false);
  const [tableCodeExist, setTableCodeExist] = useState(false);
  const [customerName, setCustomerName] = useState(
    (userInfo && userInfo.name) || carts[0].description || ""
  );
  const [businessName, setBusinessName] = useState("");
  const [businessType, setBusinessType] = useState("");
  const [latitude, setLatitude] = useState("");
  const [longitude, setLongitude] = useState("");

  const [tableCode, setTableCode] = useState("");
  const [tableNum, setTableNum] = useState(0);
  const [tableCodeFromUrl, setTableCodeFromUrl] = useState(
    sp.get("tableCode") || ""
  );
  const [code, setCode] = useState(
    sp.get("code") || localStorage.getItem("successCode") || ""
  );
  const [selectedProduct, setSelectedProduct] = useState({ _id: "" });

  const [features, setFeatures] = useState([]);
  const [feature, setFeature] = useState("");
  const [product, setProduct] = useState("");
  const [enterNameShow, setEnterNameShow] = useState(false);
  const [descriptionGatherFailed, setDescriptionGatherFailed] = useState(false);

  const [cartShow, setCartShow] = useState(false);

  const navigate = useNavigate();

  const resetHandler = () => {
    setProduct("");
    setFeature("");
    setFeatures([]);
  };

  useEffect(() => {
    setTableCodeFromUrl(sp.get("tableCode") || "");
    setCode(sp.get("code") || localStorage.getItem("successCode") || "");
  }, [sp]);

  useEffect(() => {
    new Promise((resolve) => setTimeout(resolve, 600)).then(() => {
      if (sp.get("afterSignIn") === "true") {
        setCartShow(true);
      }
    });
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (code) {
          const { data } = await axios.get(`/api/busers/description/${code}`);
          setBusinessName(data.businessName);
          setBusinessType(data.businessType);
          setLatitude(data.latitude);
          setLongitude(data.longitude);
          localStorage.setItem("successCode", code);
        } else {
          setDescriptionGatherFailed(true);
        }
      } catch (err) {
        setDescriptionGatherFailed(true);
      }
    };
    fetchData();
  }, [code]);

  useEffect(() => {
    if (descriptionGatherFailed) {
      setCode(localStorage.getItem("successCode"));
      setDescriptionGatherFailed(false);
    }
  }, [descriptionGatherFailed]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const { data } = await axios.get(
          `/api/categories/leafes/qrmenu?code=${code}`
        );
        const { data: firstOrderProducts } = await axios.get(
          `/api/products/firstOrder/${code}`
        );
        setLoading(false);
        setCategories(data);
        setFirstOrderProducts(firstOrderProducts.products);
      } catch (err) {
        navigate(`/qrmenu?code=${localStorage.getItem("successCode")}`);
        setLoading(false);
      }
    };
    if (code && businessName) {
      fetchData();
    }
  }, [businessName, code]);

  useEffect(() => {
    setTableCodeExist(!!tableCode || (userInfo && userInfo.isCustomer));
  }, [tableCode, userInfo]);

  /*useEffect(() => {
    const interval = setInterval(() => {
      if (tableCode) {
        handleQrCode('?tableCode=' + tableCode, false);
      }
    }, 1000 * 60);

    return () => clearInterval(interval);
  }, [tableCode]);*/

  useEffect(() => {
    if (tableCodeFromUrl) {
      handleQrCode(`?tableCode=${tableCodeFromUrl}&code=${code}`, false);
    }
  }, [tableCodeFromUrl]);

  useEffect(() => {
    ctxDispatch({ type: "SELECT_TABLE", payload: 1 });
  }, [ctxDispatch]);

  const handleQrCode = (qrurl, comingFromQrReader) => {
    const sp = new URLSearchParams(qrurl.slice(qrurl.indexOf("?")));

    const fetchData = async () => {
      try {
        const { data } = await axios.get(
          `/api/customer/code?tableCode=${sp.get("tableCode")}&code=${sp.get(
            "code"
          )}`
        );
        setTableNum(data.tableNum);
        setTableCode(data.tableCode);
        localStorage.setItem("successCode", sp.get("code"));
        setCode(sp.get("code"));

        if (comingFromQrReader) {
          if (customerName) {
            approveOrder(data.tableCode, customerName);
          } else {
            setScanBarcode(false);
            setEnterNameShow(true);
            setCartShow(false);
          }
        }
      } catch (err) {
        gecersizKod();
      }
    };
    fetchData();
  };

  const gecersizKod = () => {
    /*setTableNum('');
    setTableCode('');
    localStorage.removeItem('tableCode');
    localStorage.removeItem('tableNum');
    ctxDispatch({ type: 'CART_REMOVE_FIRST_TABLE' });
    setScanBarcode(false);*/
    toast.error("Gecersiz kod, lutfen garsondan yeni karekod isteyiniz.");
  };

  const approveOrder = async (tableCode, customerName, address) => {
    try {
      if (carts && carts[0] && carts[0].cartItems) {
        const cartItems = carts[0].cartItems.filter(
          (item, index) => !item.tableCode
        );

        const cartItemsMapped = cartItems.map((i) => {
          return { ...i, tableCode, alert: true };
        });

        if (userInfo?.clientCode) {
          if (!address || !address._id) {
            toast.error("Adres bilgisi zorunludur!");
            return;
          }
          await axios.put(`/api/customer/homeorder/${userInfo.clientCode}`, {
            cartItems: cartItemsMapped,
            customerName,
            address,
            alert: true,
          });
        } else {
          await axios.put(`/api/customer/${tableCode}`, {
            cartItems: cartItemsMapped,
            businessOwner: code,
            customerName,
            orderCode: uuidv4(),
          });
        }

        ctxDispatch({
          type: "CART_CUSTOMER_APPROVE",
          payload: {
            tableCode,
            tableNum: 1,
          },
        });

        if (customerName) {
          ctxDispatch({
            type: "CART_CHANGE_DESCRIPTION",
            payload: {
              description: customerName,
              tableNum: 1,
            },
          });
        }
        setScanBarcode(false);
        setCartShow(false);
        localStorage.setItem("customerName", customerName);
      }
      toast.success("Siparişiniz alınmıstır.");
    } catch (err) {
      gecersizKod();
    }
  };

  return !code ? (
    <MessageBox variant="danger">İşletme bilgisine ulaşılamadı!</MessageBox>
  ) : loading ? (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
      }}
    >
      <LoadingBox>Menü yükleniyor, bekleyiniz!</LoadingBox>
    </div>
  ) : scanBarcode ? (
    <>
      <Button
        type="button"
        className="textDecorationNone"
        variant="danger"
        onClick={() => setScanBarcode(false)}
      >
        <i className="fas fa-caret-left"></i>
        &nbsp;Iptal
      </Button>
      <div className="mt-3">
        <span className="text-danger">
          Sipariş vermek için garsondan karekod isteyiniz!
        </span>
      </div>
      <QrReader
        constraints={{ facingMode: "environment" }}
        onResult={(result, error) => {
          if (!!result) {
            handleQrCode(result?.text, true);
          }

          if (!!error) {
          }
        }}
        style={{ width: "100%" }}
      />
      <div className="text-align-center">
        <LoadingBox>Karekod okunuyor...</LoadingBox>
      </div>
    </>
  ) : (
    <div>
      <Navbar
        fixed="top"
        style={{
          zIndex: "998",
          background: "white",
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
        }}
      >
        <Container style={{ position: "relative" }} className="small-container">
          <BusinessBanner
            businessName={businessName}
            businessType={getBusinessLabel(businessType)}
          />

          <Navbar.Collapse
            style={{ position: "absolute", right: "0px", bottom: "5px" }}
          >
            <Nav.Link onClick={() => setCartShow(true)} href="">
              <div className="fitContent" style={{ position: "relative" }}>
                {carts[0].cartItems.filter((i) => !i.tableCode).length > 0 && (
                  <Badge
                    pill
                    bg="danger"
                    className="cart-badge"
                    style={{
                      position: "absolute",
                      top: "1px",
                      right: "1px",
                    }}
                  >
                    {carts[0].cartItems.filter((i) => !i.tableCode).length}
                  </Badge>
                )}
              </div>
            </Nav.Link>
          </Navbar.Collapse>
        </Container>

        <Container className="text-align-center small-container p-0">
          <div className=" container p-0 m-0">
            <CategoryMenu
              resetHandler={resetHandler}
              style={{ position: "fixed" }}
              categories={categories}
              setProducts={setProducts}
            ></CategoryMenu>
          </div>
        </Container>
      </Navbar>

      <Container className="text-align-center p-0">
        <div style={{ marginTop: "15rem" }}>
          {loading ? (
            <LoadingBox>Menu yukleniyor...</LoadingBox>
          ) : (
            <div
              className="small-container container p-0"
              style={{
                textAlign: "start",
              }}
            >
              {
                <>
                  <ProductsListForCustomer
                    products={
                      products.length > 0 ? products : firstOrderProducts
                    }
                    tableNum={1}
                    feature={feature}
                    features={features}
                    product={product}
                    setProduct={setProduct}
                    setFeature={setFeature}
                    setFeatures={setFeatures}
                  ></ProductsListForCustomer>
                </>
              }
            </div>
          )}

          <CustomerCartModal
            businessName={businessName}
            longitude={longitude}
            latitude={latitude}
            code={code}
            cartShow={cartShow}
            setCartShow={setCartShow}
            customerName={customerName}
            setCustomerName={setCustomerName}
            table={table}
            setScanBarcode={setScanBarcode}
            tableCodeExist={tableCodeExist}
            carts={carts}
            approveOrder={approveOrder}
            tableCode={tableCode}
          ></CustomerCartModal>

          <AskCustomerNameAndApproveOrderModal
            enterNameShow={enterNameShow}
            setEnterNameShow={setEnterNameShow}
            customerName={customerName}
            setCustomerName={setCustomerName}
            approveOrder={approveOrder}
            tableCode={tableCode}
          ></AskCustomerNameAndApproveOrderModal>
        </div>
      </Container>
    </div>
  );
}
